/* eslint-disable react/no-danger */
import * as _ from 'lodash-es';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../styles.module.scss';

const cardHeights = {
  sm: {
    height: '242px',
    maxHeight: '242px',
  },
  md: {
    height: '464px',
    maxHeight: '464px',
  },
};

const cx = classNames.bind(styles);

const SportRosterGrid = ({ formats }) => {
  const [flipIndex, setFlipIndex] = useState([]);

  return (
    <div className={cx('card', 'px-0')} style={{ ...cardHeights.md, overflow: 'scroll' }}>
      <h2 className="text-center w-100 mb-3">Available Formats</h2>
      {!_.isEmpty(formats) ? (
        _.map(
          formats,
          (
            { description, format, gender, maxPlayersOnField, minPlayersPerGame, minTeamSize },
            i
          ) => {
            const { total: maxTotal, male: maxMale, female: maxFemale } = maxPlayersOnField || {};
            const { total: minTotal, male: minMale, female: minFemale } = minPlayersPerGame || {};
            const { total: teamTotal, male: teamMale, female: teamFemale } = minTeamSize || {};
            return (
              <div
                {...{
                  className: cx('formats', _.includes(flipIndex, i) && 'flipped'),
                  key: i,
                  ...(!!description && {
                    role: 'button',
                    style: {},
                    tabIndex: 0,
                    onClick: () => {
                      if (_.includes(flipIndex, i)) {
                        setFlipIndex(_.pull(flipIndex, i));
                        return;
                      }
                      setFlipIndex(_.concat(flipIndex, i));
                    },
                  }),
                }}
              >
                {_.includes(flipIndex, i) ? (
                  <div className={cx('back')}>
                    <div className={cx('avatar', 'col-4')}>
                      {`${gender || ''}\n${format || ''}`}
                    </div>
                    <div className={cx('description', 'col-8')}>
                      <span>Format Description: </span>
                      <span dangerouslySetInnerHTML={{ __html: description || 'Coming Soon!' }} />
                    </div>
                  </div>
                ) : (
                  <div
                    {...{
                      className: cx('front'),
                      ...(!description && { style: { cursor: 'not-allowed' } }),
                    }}
                  >
                    <div className={cx('avatar', 'col-4')}>
                      {`${gender || ''}\n${format || ''}`}
                    </div>
                    <div className="col-8">
                      <div className={cx('description')}>
                        <div className={cx('descTitle')}>Minimum Roster Size:</div>
                        <div className={cx('descInfo')}>
                          {teamTotal || 'N/A'}&nbsp;{teamMale > 0 ? `| ${teamMale} Male` : ''}&nbsp;
                          {teamFemale > 0 ? `| ${teamFemale} Female` : ''}
                        </div>
                      </div>
                      <div className={cx('description')}>
                        <div className={cx('descTitle')}>Maximum Players on Field:</div>
                        <div className={cx('descInfo')}>
                          {maxTotal || 'N/A'}&nbsp;{maxMale > 0 ? `| ${maxMale} Male` : ''}&nbsp;
                          {maxFemale > 0 ? `| ${maxFemale} Female` : ''}
                        </div>
                      </div>
                      <div className={cx('description')}>
                        <div className={cx('descTitle')}>Minimum Players to Start Game:</div>
                        <div className={cx('descInfo')}>
                          {minTotal || 'N/A'}&nbsp;{minMale > 0 ? `| ${minMale} Male` : ''}&nbsp;
                          {minFemale > 0 ? `| ${minFemale} Female` : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          }
        )
      ) : (
        <div className={cx('formats', 'text-center')}>
          <h3>Check back for updates!</h3>
        </div>
      )}
    </div>
  );
};

const totalsTypes = {
  total: PropTypes.number,
  male: PropTypes.number,
  female: PropTypes.number,
};

SportRosterGrid.propTypes = {
  formats: PropTypes.arrayOf({
    description: PropTypes.string,
    format: PropTypes.string,
    formatImage: PropTypes.shape({ url: PropTypes.string }),
    gender: PropTypes.string,
    maxPlayersOnField: PropTypes.shape(totalsTypes),
    minPlayersPerGame: PropTypes.shape(totalsTypes),
    minTeamSize: PropTypes.shape(totalsTypes),
  }).isRequired,
};

export default SportRosterGrid;
